import moment from 'moment';
import request from '../../../util/SuperagentUtils';
import { DateFormats } from '../../constants/securspace-constants';
import { buyerInventoryReportEndpoints } from '../../../requests/api-endpoints';


const getQueryParams = (searchParams, isPageable) => {
  const { page, size, startDate, endDate, locationId, bookingNumber, equipmentType, equipmentNumber, sortBy, sortDir } = searchParams;

  let queryParams;
  if (isPageable) {
    let pageParam = ["page", page || 0];
    let sizeParam = ["size", size || 10];
    queryParams = new URLSearchParams([pageParam, sizeParam]);
  } else {
    queryParams = new URLSearchParams();
  }

  if (startDate) queryParams.append("startDate", moment(startDate).format(DateFormats.DAY));
  if (endDate) queryParams.append("endDate", moment(endDate).format(DateFormats.DAY));

  if (locationId) queryParams.append("locationId", locationId);
  if (bookingNumber) queryParams.append("bookingNumber", bookingNumber);
  if (equipmentType) queryParams.append("equipmentType", equipmentType);
  if (equipmentNumber) queryParams.append("equipmentNumber", equipmentNumber);

  if (sortBy) queryParams.append("sortBy", sortBy);
  if (sortDir) queryParams.append("sortDir", sortDir);

  return queryParams.toString();
}

const getAllBuyerInventory = (
  searchParams,
  onSuccess,
  onFail
) => {
  const result = request.get(`${buyerInventoryReportEndpoints.search}?${getQueryParams(searchParams, true)}`);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

const getBuyerInventoryReportUrl = (searchParams) => {
  return `${buyerInventoryReportEndpoints.report}?${getQueryParams(searchParams, false)}`;
}

export {
  getAllBuyerInventory,
  getBuyerInventoryReportUrl
}